var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
var messages = defineMessages({
    VerifyDomain: {
        id: 'VerifyDomain',
        defaultMessage: 'VerifyDomain',
    },
    Domain: {
        id: 'Domain',
        defaultMessage: 'Domain',
    },
    VerifyingDomainInfo: {
        id: 'VerifyingDomainInfo',
        defaultMessage: 'Verifying the domain is needed in order for e-mails that are sent from {companyEmail} via AdminPulse to be authenticated. If the domain is not authenticated within AdminPulse, e-mails might end up in the spam folder.',
    },
    IfDomainNotCorrect: {
        id: 'IfDomainNotCorrect',
        defaultMessage: "If the domain listed below is not the domain you want to verify, please change the emailaddress under menu item 'Own Company'",
    },
    InOrderToVerify: {
        id: 'InOrderToVerify',
        defaultMessage: 'In order to verify a domain, you will need:',
    },
    NeedDomainName: {
        id: 'NeedDomainName',
        defaultMessage: 'A domain name such as myoffice.be, e-mail providers like Gmail will not work.',
    },
    NeedCnameAccess: {
        id: 'NeedCnameAccess',
        defaultMessage: 'Access to the CNAME records of this domain, your IT provider will probably be able to help you with this.',
    },
});
var AddEmailDomainModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, onSave = _a.onSave, suggestedEmailDomain = _a.suggestedEmailDomain, companyId = _a.companyId, companyEmail = _a.companyEmail;
    var intl = useIntl();
    var _b = useState(suggestedEmailDomain || ''), domain = _b[0], setDomain = _b[1];
    var _c = useState(false), saving = _c[0], setSaving = _c[1];
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!domain)
                        return [2 /*return*/];
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.base.post('/api/settings/CreateEmailDomain', {
                            companyId: companyId,
                            domain: domain,
                        })];
                case 2:
                    response = _a.sent();
                    onSave(response.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleHttpError(intl)(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(OkCancelModal, __assign({ title: intl.formatMessage(messages.VerifyDomain), show: show, onClose: onClose, onSave: handleSave, disabled: saving || !domain, disableFullScreen: true }, { children: [_jsxs("div", __assign({ className: "alert alert-info" }, { children: [_jsx("div", { children: intl.formatMessage(messages.VerifyingDomainInfo, { companyEmail: companyEmail }) }), _jsx("div", { children: intl.formatMessage(messages.IfDomainNotCorrect) }), _jsxs("div", { children: [_jsx("div", __assign({ className: "margin10T" }, { children: intl.formatMessage(messages.InOrderToVerify) })), _jsxs("ul", __assign({ style: { paddingLeft: 18 } }, { children: [_jsx("li", { children: intl.formatMessage(messages.NeedDomainName) }), _jsx("li", { children: intl.formatMessage(messages.NeedCnameAccess) })] }))] })] })), _jsx("div", __assign({ className: "form-horizontal", role: "form" }, { children: _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "domain", className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.Domain) })), _jsx("div", __assign({ className: "col-sm-8" }, { children: _jsx("input", { type: "text", id: "domain", name: "domain", className: "form-control", value: domain, onChange: function (e) { return setDomain(e.target.value); }, placeholder: intl.formatMessage(messages.Domain), required: true }) }))] })) }))] })));
};
export default AddEmailDomainModal;
